module.exports = __webpack_public_path__ + "rental-portfolios-2.1886781.png";